import Checkbox from '../../../components/checkBox/CheckBox';
import Card from '../../../components/card/Card';
import P from '../../../components/texts/p/P';
import { useEffect, useState } from 'react';
import { useClientTheme } from '../../../context/ThemeContext';
import {
  getApplication,
  sendApplication,
  updateApplication,
} from '../../../services/ApplicationService';
import Modal from '../../../components/modal/modal';
import { Toast, useToast } from '../../../components/toast/toast';
import TextArea from '../../../components/textarea/TextArea';
import { APPLICATION_STATUS } from '../../../utils/Constants';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SummmaryPartners from './Partners';
import SummaryDocuments from './Documents';
import ValidityFrame from './Validity';
import H from '../../../components/texts/h/H';
import Button from '../../../components/button/Button';
import Tooltip from '../../../components/tooltip/Tooltip';
import JSZip from 'jszip';
import { downloadApplicationDocumentToBlob } from '../../../utils/downloadApplicationDocumentToBlob';
import { legalEntities } from '../../../mocks/LegalEntities';
import { getOtherLegalEntitiesFileTypes } from '../../../services/ApplicationService';
import { useConfig } from '../../../context/ConfigContext';
import {
  getRequiredDocumentsForLegalEntity,
  findDocumentForRequiredSlot,
  isOriginationExtraDocument,
} from '../../../utils/originationRequiredDocuments';

import { hasData, isSuccessfulResponse, toNumber } from '../../../utils/Utils';
import ActionButtonBar from '../../ActionButtonBar/ActionButtonBar';
import { routes } from '../../../routes/routePaths';
import {
  navigateAfterFlowAction,
  type DetailLocationState,
} from '../../../utils/listNavigationState';
import SummaryAmounts from '../../common/SummaryAmounts';
import renderBasicData from '../../common/BasicData';
import { clientData } from '../../../types/interfaces';
import DropDown from '../../../components/dropdown/DropDown';
import Input from '../../../components/input/Input';
import { useOperationTypes } from '../../../hooks/useOperationTypes';
import { useRiskAnalysts } from '../../../hooks/useRiskAnalysts';
import useRole from '../../../hooks/useRole';
import { applicationInfo } from '../../../types/interfaces';
import CloseApplicationModal from '../../Instrumentation/InstrumentationModals/CloseApplicationModal';
import { isSyndicatedClosePath } from '../../../utils/syndicatedPublicOperations';
import { isFinishedStatus } from '../../../utils/applicationStatusUtils';
interface SummaryProps {
  applicationStatus: number;
  onPreviousClick?: () => void;
  setClientData: Function;
  isSaving: boolean;
  clientData: clientData;
  onLoadClientData: Function;
  isClientDataLoaded: boolean;
  showButtons?: boolean;
  showPartners?: boolean;
  showSummaryDocuments?: boolean;
  showValidateComposition?: boolean;
  showSummaryApplication?: boolean;
  viewOnly?: boolean;
  hideDownloadButtons?: boolean;
}

type OriginationDataModalMode = 'send' | 'approve';

const Summary: React.FC<SummaryProps> = ({
  applicationStatus,
  setClientData,
  onPreviousClick,
  isSaving,
  clientData,
  onLoadClientData,
  isClientDataLoaded,
  showButtons = true,
  showPartners = true,
  showSummaryDocuments = true,
  showValidateComposition = true,
  showSummaryApplication = true,
  viewOnly = false,
  hideDownloadButtons = false,
}) => {
  const config = useConfig();
  const [isRejectApplication, setIsRejectApplication] =
    useState<boolean>(false);
  const [isApproveApplicationOpen, setIsApproveApplication] =
    useState<boolean>(false);
  const [isSentApplicationOpen, setIsSentApplicationOpen] =
    useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('');
  const [modalOperationTypeId, setModalOperationTypeId] = useState<number | undefined>(undefined);
  const [modalSaldoInput, setModalSaldoInput] = useState<string>('');
  const [modalAssignedRiskAnalystId, setModalAssignedRiskAnalystId] = useState<
    number | undefined
  >(undefined);
  const [modalMode, setModalMode] = useState<OriginationDataModalMode>('approve');
  const { cuit, id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = (location.state ?? {}) as DetailLocationState;
  const [isSendingApplication, setIsSendingApplication] =
    useState<boolean>(false);
  const [isCloseSyndicatedOpen, setIsCloseSyndicatedOpen] =
    useState<boolean>(false);
  const [clientInfo, setClientInfo] = useState<clientData>(clientData);
  const [bulkDownloading, setBulkDownloading] = useState(false);
  const { clientTheme } = useClientTheme();
  const [otherLegalEntities, setOtherLegalEntities] = useState<Array<{id: number; code: string; description: string}>>([]);
  const useSyndicatedClose = isSyndicatedClosePath(
    config.isSyndicatedPublicOperationsEnabled,
    clientInfo.is_syndicated
  );

  useEffect(() => {
    if (cuit && id && !isClientDataLoaded) {
      getApplication(cuit, id).then((response) => {
        if (hasData(response) && isSuccessfulResponse(response)) {
          const serverData = response.data;
          setClientInfo((prev) => {
            const merged = {
              ...serverData,
              operation_type_id: prev.operation_type_id ?? serverData.operation_type_id,
              operation_type_label: prev.operation_type_label ?? serverData.operation_type_label,
            };
            return merged;
          });
          setClientData(serverData);
          onLoadClientData(true);
        }
      });
    }
  }, [cuit, id, isClientDataLoaded]);

  useEffect(() => {
    if (isClientDataLoaded) {
      setClientInfo((prev) => {
        const merged = {
          ...clientData,
          operation_type_id: prev.operation_type_id ?? clientData.operation_type_id,
          operation_type_label: prev.operation_type_label ?? clientData.operation_type_label,
        };
        return merged;
      });
    }
  }, [clientData, isClientDataLoaded]);

  // Fetch de tipos de documentos al montar el componente
  useEffect(() => {
    const fetchOtherLegalEntities = async () => {
      try {
        const response = await getOtherLegalEntitiesFileTypes();
        if (response.success && response.data) {
          setOtherLegalEntities(response.data);
        }
      } catch (error) {
        console.error('Error fetching other legal entities:', error);
      }
    };

    fetchOtherLegalEntities();
  }, []);

  const { operationTypes } = useOperationTypes();
  const isOriginationDataModalEnabled = config.isOriginationDataModalEnabled ?? false;
  const { riskAnalysts } = useRiskAnalysts(isOriginationDataModalEnabled);
  const { isProducer } = useRole();
  const canShowModalRiskAnalyst = !isProducer;
  const canEditModalRiskAnalyst = canShowModalRiskAnalyst && !viewOnly;
  const isStatusNaN = isNaN(applicationStatus);
  const shouldShowOriginationDataModalOnSend =
    isOriginationDataModalEnabled && isStatusNaN && !isProducer;

  const getOperationTypeLabel = (id?: number) =>
    operationTypes.find((opt) => opt.id === id)?.label;

  const getModalRiskAnalystTitle = () => {
    if (modalAssignedRiskAnalystId === undefined) {
      return 'Seleccioná un analista';
    }
    const selected = riskAnalysts.find((a) => a.id === modalAssignedRiskAnalystId);
    return selected?.label || 'Seleccioná un analista';
  };

  useEffect(() => {
    if (!isApproveApplicationOpen || !isOriginationDataModalEnabled) return;
    setModalOperationTypeId(clientInfo.operation_type_id);
    setModalSaldoInput(
      clientInfo.current_sgr_balance != null
        ? String(clientInfo.current_sgr_balance)
        : '',
    );
    setModalAssignedRiskAnalystId(clientInfo.assigned_risk_analyst_id ?? undefined);
  }, [isApproveApplicationOpen, isOriginationDataModalEnabled, clientInfo]);

  const parseModalSaldo = (raw: string): number | undefined => {
    const trimmed = raw.trim();
    if (!trimmed) return undefined;
    const parsed = toNumber(trimmed.replace(/\$/g, '').replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : undefined;
  };

  const getApplicationInfo = (): applicationInfo => {
    return {
      products: clientInfo.products,
      manual_total_amount: clientInfo.manual_total_amount,
      requested_amount: clientInfo.requested_amount,
      reason: clientInfo.reason,
      review: clientInfo.review,
      extra_comments: clientInfo.extra_comments,
      has_valid_corporate_composition:
        clientInfo.has_valid_corporate_composition,
      corporate_structure: clientInfo.corporate_structure,
      signers: clientInfo.signers.map(signer => ({
        ...signer
      })),
      officer: clientInfo.officer,
      referrer_name: clientInfo.referrer_name,
      category_type_id: clientInfo.category_type_id,
      effective_date: clientInfo.effective_date,
      credit_type_id: clientInfo.credit_type_id,
      operation_type_id: clientInfo.operation_type_id,
      current_sgr_balance: clientInfo.current_sgr_balance,
      lufe_balance_source_year:
        clientData.lufe_balance_source_year ?? clientInfo.lufe_balance_source_year,
      is_syndicated: !!clientInfo.is_syndicated,
    };
  };

  const buildSendPayload = (): applicationInfo => {
    const base = getApplicationInfo();
    const saldo = parseModalSaldo(modalSaldoInput);
    const operationTypeId = modalOperationTypeId ?? clientInfo.operation_type_id;
    return {
      ...base,
      ...(operationTypeId !== undefined ? { operation_type_id: operationTypeId } : {}),
      ...(saldo !== undefined ? { current_sgr_balance: saldo } : {}),
      ...(modalAssignedRiskAnalystId !== undefined
        ? { assigned_risk_analyst_id: modalAssignedRiskAnalystId }
        : {}),
    };
  };

  const executeSend = (payload: applicationInfo) => {
    setIsSendingApplication(true);
    sendApplication(clientInfo.cuit, payload, id).then(
      (response) => {
        if (response.status === 201 || response.status === 200) {
          setClientInfo((prev) => ({
            ...prev,
            operation_type_id: payload.operation_type_id ?? prev.operation_type_id,
            operation_type_label:
              getOperationTypeLabel(payload.operation_type_id) ?? prev.operation_type_label,
            current_sgr_balance:
              payload.current_sgr_balance ?? prev.current_sgr_balance,
            assigned_risk_analyst_id:
              payload.assigned_risk_analyst_id ?? prev.assigned_risk_analyst_id,
            assigned_risk_analyst_label:
              payload.assigned_risk_analyst_id !== undefined
                ? riskAnalysts.find((a) => a.id === payload.assigned_risk_analyst_id)?.label ??
                  prev.assigned_risk_analyst_label
                : prev.assigned_risk_analyst_label,
          }));
          setIsSentApplicationOpen(true);
        } else if (response.status === 409) {
          useToast.error({
            title: 'Ya existe una solicitud existente para este cliente.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
        } else {
          useToast.error({
            title: 'Ocurrió un error inesperado. Intentá nuevamente.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
        }
        setIsSendingApplication(false);
      }
    ).catch(() => {
      setIsSendingApplication(false);
    });
  };

  const handleSubmit = () => {
    executeSend(getApplicationInfo());
  };

  const openOriginationDataModal = (mode: OriginationDataModalMode) => {
    setModalMode(mode);
    setModalOperationTypeId(clientInfo.operation_type_id);
    setModalSaldoInput(
      clientInfo.current_sgr_balance != null
        ? String(clientInfo.current_sgr_balance)
        : '',
    );
    setModalAssignedRiskAnalystId(clientInfo.assigned_risk_analyst_id ?? undefined);
    setIsApproveApplication(true);
  };

  const handleSendClick = () => {
    if (useSyndicatedClose) {
      setIsCloseSyndicatedOpen(true);
      return;
    }
    if (shouldShowOriginationDataModalOnSend) {
      openOriginationDataModal('send');
      return;
    }
    handleSubmit();
  };

  const handleSyndicatedClose = (closeText: string) => {
    const comment = (closeText ?? '').trim();
    if (!comment) {
      useToast.error({
        title: 'Ingresá un comentario para cerrar la carpeta.',
        id: 'application-toast',
        description: '',
        closeButton: false,
        autoClose: 5000,
      });
      return;
    }
    setIsCloseSyndicatedOpen(false);
    setIsSendingApplication(true);
    const payload = { ...getApplicationInfo(), is_syndicated: true };
    const closeWithStatus = (applicationId: string) =>
      updateApplication(
        cuit!,
        {
          status_code: APPLICATION_STATUS.finished.label,
          comment,
        },
        applicationId
      ).then((response) => {
        if (isSuccessfulResponse(response)) {
          useToast.success({
            title: 'Carpeta cerrada. La solicitud figura en Carpetas Cerradas.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
          setTimeout(() => {
            navigateAfterFlowAction(navigate, location.pathname, locationState);
          }, 3000);
        } else {
          useToast.error({
            title: 'Ocurrió un error al cerrar la carpeta.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
        }
        setIsSendingApplication(false);
      });

    if (Number(id) > 0) {
      sendApplication(clientInfo.cuit, payload, id!)
        .then(() => closeWithStatus(id!))
        .catch(() => {
          setIsSendingApplication(false);
          useToast.error({
            title: 'Ocurrió un error al cerrar la carpeta.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
        });
      return;
    }

    sendApplication(clientInfo.cuit, payload, id || '0')
      .then((response) => {
        const createdId =
          response?.data?.id != null
            ? String(response.data.id)
            : response?.data != null
              ? String(response.data)
              : '';
        if (!createdId) {
          setIsSendingApplication(false);
          useToast.error({
            title: 'Ocurrió un error al crear la solicitud sindicada.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
          return;
        }
        return closeWithStatus(createdId);
      })
      .catch(() => {
        setIsSendingApplication(false);
        useToast.error({
          title: 'Ocurrió un error al cerrar la carpeta.',
          id: 'application-toast',
          description: '',
          closeButton: false,
          autoClose: 5000,
        });
      });
  };

  const resetApproveModalState = () => {
    setModalText('');
    setModalOperationTypeId(undefined);
    setModalSaldoInput('');
    setModalAssignedRiskAnalystId(undefined);
  };

  const handleApplication = (status: string) => {
    setIsSendingApplication(true);
    const payload: {
      status_code: string;
      comment: string;
      operation_type_id?: number;
      assigned_risk_analyst_id?: number;
      current_sgr_balance?: number;
    } = { status_code: status, comment: modalText };

    if (
      isOriginationDataModalEnabled &&
      status === APPLICATION_STATUS.approved.label
    ) {
      if (modalOperationTypeId !== undefined) {
        payload.operation_type_id = modalOperationTypeId;
      }
      const saldo = parseModalSaldo(modalSaldoInput);
      if (saldo !== undefined) {
        payload.current_sgr_balance = saldo;
      }
      if (modalAssignedRiskAnalystId !== undefined) {
        payload.assigned_risk_analyst_id = modalAssignedRiskAnalystId;
      }
    }

    updateApplication(
      cuit!,
      payload,
      id!
    ).then((response) => {
      const mapStatus = new Map();
      mapStatus.set(
        APPLICATION_STATUS.approved.label,
        'Aceptaste la documentación. El productor será notificado.'
      );
      mapStatus.set(
        APPLICATION_STATUS.rejected.label,
        'Declinaste la solicitud. El productor será notificado.'
      );
      mapStatus.set(
        APPLICATION_STATUS.pending.label,
        'Solicitaste cambios en la solicitud. El productor será notificado.'
      );

      if (isSuccessfulResponse(response)) {
        useToast.success({
          title: mapStatus.get(status),
          id: 'application-toast',
          description: '',
          closeButton: false,
          autoClose: 5000,
        });
        setTimeout(() => {
          navigateAfterFlowAction(navigate, location.pathname, locationState);
        }, 3000);
      }
      setIsSendingApplication(false);
    });
  };

  const renderApproveModal = () => {
    if (isOriginationDataModalEnabled) {
      const isSendModal = modalMode === 'send';
      return (
        <Card>
          <P type='1' variant='neutral'>
            {isSendModal
              ? 'Al enviar la solicitud, esta pasará a análisis de riesgos. Completá los datos de la operación si los tenés disponibles.'
              : 'Antes de enviar a análisis de riesgo, completá los datos de esta operación. Podés omitirlos si no los tenés disponibles.'}
          </P>
          <Card margin={{ top: '3' }}>
            <DropDown
              id='modal-operation-type-dropdown'
              label='Tipo de operación'
              title={getOperationTypeLabel(modalOperationTypeId) || 'Seleccioná el tipo'}
              items={operationTypes.map((opt) => ({ label: opt.label }))}
              onChange={(label: string) => {
                const selected = operationTypes.find((opt) => opt.label === label);
                setModalOperationTypeId(selected?.id);
              }}
            />
          </Card>
          <Card margin={{ top: '3' }}>
            <Input
              id='modal-current-sgr-balance'
              label='Saldo vigente con la SGR'
              placeholder='0'
              value={modalSaldoInput}
              onChange={(e) => setModalSaldoInput(e.target.value)}
            />
          </Card>
          {canShowModalRiskAnalyst && (
            <Card margin={{ top: '3' }}>
              <DropDown
                id='modal-risk-analyst-dropdown'
                label='Analista de riesgo asignado'
                title={getModalRiskAnalystTitle()}
                disabled={!canEditModalRiskAnalyst}
                items={riskAnalysts.map((analyst) => ({ label: analyst.label }))}
                onChange={(label: string) => {
                  const selected = riskAnalysts.find((analyst) => analyst.label === label);
                  setModalAssignedRiskAnalystId(selected?.id);
                }}
              />
            </Card>
          )}
          <Card margin={{ top: '3' }}>
            <TextArea
              id='modal-comment'
              placeHolder={
                isSendModal
                  ? 'Escribí un comentario opcional (no se guardará al enviar).'
                  : 'Escribí un comentario sobre la documentación o dejalo en blanco.'
              }
              maxLengthHelpText={false}
              onChange={(e) => setModalText(e.target.value)}
            />
          </Card>
        </Card>
      );
    }

    return (
      <Card>
        <P type='1' variant='neutral'>
          Al aceptar la documentación de la solicitud, esta pasará a análisis de
          riesgos.
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí un comentario sobre la documentación o dejalo en blanco.'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  const renderRejectModal = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Declinar una solicitud eliminará la documentación.
        </P>
        <P type='1' variant='danger' withMargin={false}>
          Esta acción no se puede deshacer
        </P>
        <P type='1' variant='neutral' withMargin={false}>
          También podés solicitar cambios. Detallalos abajo, y la solicitud
          volverá al productor con ese pedido.
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí los cambios que solicitás, o el motivo de la denegación.'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  const renderSentApplicationModal = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Enviaste la solicitud al comercial asignado. Te llegará una
          notificación cuando cambie de estado, y podrás visualizar la carpeta
          en tu dashboard.
        </P>
      </Card>
    );
  };

  const downloadFileToBlob = async (
    filename: string
  ): Promise<{ blob: Blob; filename: string } | null> =>
    downloadApplicationDocumentToBlob(
      clientInfo.cuit || cuit || '',
      id || clientInfo.id_application?.toString(),
      filename
    );

  const handleDownloadAll = async () => {
    const documents = clientInfo.files;
    const legalEntity = clientInfo.basic_data.legal_entity;

    const requiredDocs = getRequiredDocumentsForLegalEntity(
      legalEntity,
      legalEntities,
      config
    );

    const availableBasicDocs =
      requiredDocs
        .map((document) => ({
          document,
          matchedDocument: findDocumentForRequiredSlot(documents, document.id),
        }))
        .filter(({ matchedDocument }) => Boolean(matchedDocument))
        .map(({ document, matchedDocument }) => ({
          type: 'basic',
          title: document.value,
          filename: matchedDocument?.file_name,
        })) || [];

    const availableExtraDocs = documents
      .filter((doc) => isOriginationExtraDocument(doc, requiredDocs))
      .map((doc) => ({
        type: 'extra',
        title:
          otherLegalEntities.find((item) => item.code === doc.type)?.description ||
          'Documento Extra',
        filename: doc.file_name,
      }));

    const allDocs = [...availableBasicDocs, ...availableExtraDocs];
    const hasDocuments = allDocs.length > 0;

    if (!hasDocuments) {
      return;
    }

    setBulkDownloading(true);

    try {
      const zip = new JSZip();
      let successCount = 0;

      for (const doc of allDocs) {
        try {
          if (!doc.filename) continue;

          const fileData = await downloadFileToBlob(doc.filename);

          if (fileData) {
            const folderName =
              doc.type === 'basic'
                ? 'Documentacion_Basica'
                : 'Documentacion_Extra';
            const folder = zip.folder(folderName);
            if (folder) {
              folder.file(fileData.filename, fileData.blob);
              successCount++;
            }
          }
        } catch (fileError) {
          console.error('Error downloading file:', fileError);
        }

        await new Promise((resolve) => setTimeout(resolve, 300));
      }

      if (successCount === 0) {
        alert('No se pudo descargar ningún archivo. Por favor, inténtalo de nuevo.');
        return;
      }

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const timestamp = `${year}${month}${day}-${hour}${minute}`;
      const sanitizedCompanyName = (clientInfo.basic_data?.company_name && clientInfo.basic_data.company_name.trim())
        ? clientInfo.basic_data.company_name.replace(/[^a-zA-Z0-9\s]/g, '_').replace(/\s+/g, '_')
        : cuit || 'empresa';
      const zipFilename = `${sanitizedCompanyName}-comite-${timestamp}.zip`;

      const zipBlob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 6 },
      });

      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = zipFilename;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error creating ZIP:', error);
      alert('Error al crear el archivo ZIP. Por favor, inténtalo de nuevo.');
    } finally {
      setBulkDownloading(false);
    }
  };

  const renderProductsAndRequestAmount = (clientData: clientData) => {
    return (
      <Card margin={{ top: '4' }} width='100%'>
        <Card variant={clientTheme ? 'primary' : 'success'} modifier='weak' spacing={'2'}>
          <H
            type='3'
            variant='neutral-1'
            withMargin={false}
            weight='bold'
            modifier='strong'
          >
            Solicitud
          </H>
        </Card>
        <Card margin={{ top: '4' }} width='100%'>
          <div style={{ padding: '0 8px' }}>
            <SummaryAmounts
              clientData={clientData}
              isManualAmount={clientData.manual_total_amount}
              amounts={clientData.requested_amount}
              products={clientData.products}
              hideFianzaPagare={viewOnly}
            />
          </div>
        </Card>
      </Card>
    );
  };

  return (
    <Card height='-webkit-fill-available' width='100%'>
      <CloseApplicationModal
        isOpen={isCloseSyndicatedOpen}
        onClose={() => setIsCloseSyndicatedOpen(false)}
        onSecondaryAction={() => setIsCloseSyndicatedOpen(false)}
        onPrimaryAction={(closeText: string) => handleSyndicatedClose(closeText)}
        loadingPrimaryBtn={isSendingApplication}
      />
      <Toast id='application-toast' />
      <Modal
        isOpen={isRejectApplication}
        onClose={() => setIsRejectApplication(false)}
        title={'Declinar o solicitar cambios'}
        primaryText='Solicitar cambios'
        primaryVariant='primary'
        secondaryText='Declinar solicitud'
        secondaryVariant='secondary'
        onSecondaryAction={() => {
          setIsRejectApplication(false);
          handleApplication(APPLICATION_STATUS.rejected.label);
        }}
        onPrimaryAction={() => {
          setIsRejectApplication(false);
          handleApplication(APPLICATION_STATUS.pending.label);
        }}
        children={renderRejectModal()}
      />
      <Modal
        isOpen={isApproveApplicationOpen}
        onClose={() => {
          setIsApproveApplication(false);
          resetApproveModalState();
        }}
        title={isOriginationDataModalEnabled ? 'Datos de la operación' : 'Aceptar documentación de solicitud'}
        width={isOriginationDataModalEnabled ? '544px' : '448px'}
        primaryText={
          isOriginationDataModalEnabled
            ? modalMode === 'send'
              ? 'Enviar solicitud'
              : 'Guardar y enviar'
            : 'Aceptar documentación'
        }
        primaryVariant='primary'
        secondaryText='Cancelar'
        secondaryVariant='secondary'
        onSecondaryAction={() => {
          setIsApproveApplication(false);
          resetApproveModalState();
        }}
        onPrimaryAction={() => {
          setIsApproveApplication(false);
          if (modalMode === 'send') {
            executeSend(buildSendPayload());
          } else {
            handleApplication(APPLICATION_STATUS.approved.label);
          }
          resetApproveModalState();
        }}
        children={renderApproveModal()}
      />
      <Modal
        isOpen={isSentApplicationOpen}
        onClose={() => setIsSentApplicationOpen(false)}
        title={'Solicitud enviada'}
        primaryText='Ir al dashboard'
        primaryVariant='primary'
        secondaryText='Alta de nueva carpeta'
        secondaryVariant='secondary'
        onSecondaryAction={() => {
          setIsSentApplicationOpen(false);
          window.location.reload();
        }}
        onPrimaryAction={() => navigate(routes.dashboard)}
        children={renderSentApplicationModal()}
      />

      {renderBasicData(clientInfo, {
        isSyndicated: !!(clientInfo.is_syndicated || useSyndicatedClose),
      })}

      {showValidateComposition && (
        <Card width='100%'>
          <Card variant={clientTheme ? 'primary' : 'success'} modifier='weak' spacing={'2'}>
            <H
              type='3'
              variant='neutral-1'
              withMargin={false}
              weight='bold'
              modifier='strong'
            >
              Socios
            </H>
          </Card>
          <Card
            display='flex'
            justifyContent='flex-end'
            gap='4px'
            margin={{ top: '2' }}
          >
            <Checkbox
              checked={clientInfo.has_valid_corporate_composition}
              disabled={true}
              id='summary_has_valid_corporate_composition-checkbox'
              size='md'
            >
              La información se ajusta a los documentos
            </Checkbox>
          </Card>
        </Card>
      )}
      {showPartners && (
        <SummmaryPartners
          partners={clientInfo.corporate_structure}
        ></SummmaryPartners>
      )}
      {isFinishedStatus(applicationStatus) && clientInfo.validity != null && (
        <Card margin={{ top: '4' }} width='100%'>
          <ValidityFrame validity={clientInfo.validity} />
        </Card>
      )}
      {showSummaryDocuments && (
        <Card margin={{ top: '4' }} width='100%'>
          <Card variant={clientTheme ? 'primary' : 'success'} modifier='weak' spacing={'2'} display='flex' justifyContent='space-between' alignItems='center' width='100%'>
            <H
              type='3'
              variant='neutral-1'
              withMargin={false}
              weight='bold'
              modifier='strong'
            >
              Documentación
            </H>
            {!hideDownloadButtons && (
              <Card>
                {(() => {
                  const documents = clientInfo.files;
                  const legalEntity = clientInfo.basic_data.legal_entity;
                  const requiredDocuments = getRequiredDocumentsForLegalEntity(
                    legalEntity,
                    legalEntities,
                    config
                  );
                  const hasDocuments =
                    documents.some(
                      (doc) =>
                        doc.is_basic_data &&
                        requiredDocuments.some((reqDoc) => reqDoc.id === doc.type)
                    ) || documents.some((doc) => !doc.is_basic_data);

                  return !hasDocuments ? (
                    <Tooltip
                      position='top'
                      showArrow={true}
                      msg='Esta solicitud no tiene archivos'
                    >
                      <Button
                        variant='primary'
                        size='md'
                        icon='download_outline'
                        iconAlign='left'
                        onClick={handleDownloadAll}
                        disabled={true}
                      >
                        Descargar todos
                      </Button>
                    </Tooltip>
                  ) : (
                    <Button
                      variant='primary'
                      size='md'
                      icon='download_outline'
                      iconAlign='left'
                      onClick={handleDownloadAll}
                      disabled={bulkDownloading}
                    >
                      {bulkDownloading ? 'Creando ZIP...' : 'Descargar todos'}
                    </Button>
                  );
                })()}
              </Card>
            )}
          </Card>
          <SummaryDocuments
            cuit={clientInfo.cuit}
            documents={clientInfo.files}
            legalEntity={clientInfo.basic_data.legal_entity}
            applicationId={id}
          />
        </Card>
      )}

      {showSummaryApplication && renderProductsAndRequestAmount(clientData)}

      {showButtons && (
        <ActionButtonBar
          applicationStatus={applicationStatus}
          isSaving={isSaving}
          onPreviousClick={onPreviousClick ? onPreviousClick : () => {}}
          handleSubmit={handleSendClick}
          isSendingApplication={isSendingApplication}
          navigate={navigate}
          setIsApproveApplication={setIsApproveApplication}
          setIsRejectApplication={setIsRejectApplication}
          onApproveClick={() => openOriginationDataModal('approve')}
          submitButtonText={useSyndicatedClose ? 'Cerrar carpeta' : 'Enviar solicitud'}
          isSyndicatedClosePath={useSyndicatedClose}
        />
      )}
    </Card>
  );
};

export default Summary;
